import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./combineAllReducers";

const persistConfig = {
  key: "root",
  storage,

  whitelist: ["authReducer", "subscriptionReducer", "ammenitiesRangeReducer", "FCMReducer", "walletPaymentReducer", "subscriptionExpiredReducer"],
  blacklist: ["commonReducer", "loadingReducer", "generalApiReducer", "notificationReducer"],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
// const store = configureStore({
//   reducer: persistedReducer,
// });


const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
